<template>
    <div class="Report__field__content">
        <div
            v-if="submission"
            class="Report__field__submission"
        >
            <v-text-field
                type="text"
                readonly
                :label="field.name"
                v-model="submission.text"
                dense
                outlined
            />

            <CopyFieldValue :value="submission.text" />
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import CopyFieldValue from '@/reports/Fields/Common/CopyFieldValue';
export default {
    components: { CopyFieldValue},
    mixins: [
        ReportFieldBoilerplate,
    ]
};
</script>
